import React from 'react'
import { IconCrossCircled, IconTickCircled } from '../../../../icons'
import { SubscriptionPackageFeatureValue } from './MiniSubscriptionPackage'
import { StyledMiniSubscriptionPackageBenefit } from './MiniSubscriptionPackage.styled'
import { SubscriptionPackageBenefitValue } from './SubscriptionPackage'
import {
    BreachOptions,
    PackageOptions,
    StyledSubscriptionPackageBenefit,
} from './SubscriptionPackage.styled'

export interface SubscriptionPackageBenefitProps {
    benefit: SubscriptionPackageBenefitValue | SubscriptionPackageFeatureValue
    containerComponent?:
        | typeof StyledSubscriptionPackageBenefit
        | typeof StyledMiniSubscriptionPackageBenefit
    color?: string
    packageOptions?: PackageOptions
    breachOptions?: BreachOptions
}

export const SubscriptionPackageBenefit = ({
    benefit,
    containerComponent = StyledSubscriptionPackageBenefit,
    color,
    packageOptions,
    breachOptions,
}: SubscriptionPackageBenefitProps) => {
    const Container = containerComponent
    const packageColor =
        packageOptions?.theme === 'optimise-blue' ? '#043de2' : color
    return (
        <Container
            packageOptions={packageOptions}
            breachOptions={breachOptions}
        >
            {benefit.isAvailable ? (
                <IconTickCircled
                    width={20}
                    height={20}
                    idSuffix={
                        benefit.name.replace(/\W/g, '-') +
                        Math.random().toFixed(5).replace('0.', '')
                    }
                    color={packageColor}
                />
            ) : (
                <IconCrossCircled width={20} height={20} />
            )}
            <span>
                {benefit.name === 'Unlimited access to thewest.com.au' ? (
                    <>
                        Unlimited access to{' '}
                        <a href="https://thewest.com.au">thewest.com.au</a>
                    </>
                ) : (
                    benefit.name
                )}
            </span>
        </Container>
    )
}
